import { message } from 'antd';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import { logOut } from '../authentication/actionCreator';
import { getItem } from '../../utility/localStorageControl';

const {
  progressAddBegin,
  progressAddSuccess,
  progressAddErr,

  progressCommentAddBegin,
  progressCommentAddSuccess,
  progressCommentAddErr,

  getProgressByTaskReadBegin,
  getProgressByTaskReadSuccess,
  getProgressByTaskReadErr,
  
  todayProgressReadBegin,
  todayProgressReadSuccess,
  todayProgressReadErr,
} = actions;

const progressDataSubmit = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(progressAddBegin());
      const response = await DataService.post('/progress-info/create', data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(progressAddSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(progressAddSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(progressAddSuccess(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(progressAddErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const progressCommentDataSubmit = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(progressCommentAddBegin());
      const response = await DataService.put('/progress-info/add-comment', data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(progressCommentAddSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(progressCommentAddSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(progressCommentAddSuccess(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(progressCommentAddErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const getProgressByTaskDataRead = (taskId) => {
  return async (dispatch) => {
    try {
      await dispatch(getProgressByTaskReadBegin());
      const response = await DataService.get(`/tasks/progress-info/${taskId}`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(getProgressByTaskReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(getProgressByTaskReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(getProgressByTaskReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(getProgressByTaskReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const todayProgressDataRead = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(todayProgressReadBegin());
      const response = await DataService.post(`/progress-info/getByDate`, data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(todayProgressReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(todayProgressReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(todayProgressReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(todayProgressReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

export {
  getProgressByTaskDataRead,
  progressDataSubmit,
  todayProgressDataRead,
  progressCommentDataSubmit,
};
